import React from "react";
import img1 from "../../images/manufacturerBenefits/service (1).svg";
import img2 from "../../images/manufacturerBenefits/organic.svg";
import img3 from "../../images/manufacturerBenefits/search.svg";
import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";

export default function WorkOrderStackBenefits() {
  const benefits = [
    {
      img: img1,
      title: "Efficient Workflow Management ",
      bodycopy:
        "Streamline the creation, assignment, and monitoring of work orders to ensure tasks are completed in a timely manner.",
    },
    {
      img: img2,
      title: "Real-Time Visibility",
      bodycopy:
        "Gain immediate insights into the status of each work order, allowing for quicker adjustments and better decision-making.",
    },
    {
      img: img3,
      title: "Optimized Resource Usage",
      bodycopy:
        "Efficiently assign work orders to the right production units and manage raw materials, reducing waste and improving productivity.",
    },
    {
      img: img3,
      title: "Enhanced Quality Control",
      bodycopy:
        "Ensure the consistency and quality of outputs by integrating inspections and quality checks at each stage of the work order.",
    },

    {
      img: img3,
      title: "Cost and Time Savings",
      bodycopy:
        "Monitor production time and costs closely, minimizing overruns and improving overall manufacturing profitability.",
    },
    {
      img: img3,
      title: "Improved Communication",
      bodycopy:
        "Keep all team members and stakeholders updated with real-time work order status, improving collaboration and reducing delays.",
    },

    {
      img: img3,
      title: "Efficient Workflow Management",
      bodycopy:
        "Streamline the creation, assignment, and tracking of work orders to ensure all tasks are completed on time.",
    },
    {
      img: img3,
      title: "Enhanced Visibility",
      bodycopy:
        "Gain clear insights into the status of each work order, allowing for better decision-making and proactive issue resolution.",
    },
    {
      img: img3,
      title: "Optimized Resource Allocation",
      bodycopy:
        "Easily assign work orders to the appropriate farming sites, ensuring the right resources are used at the right time.",
    },
    {
      img: img3,
      title: "Comprehensive Oversight",
      bodycopy:
        "With a full history of work order statuses, managers can track performance, ensure compliance, and audit processes more effectively.",
    },
  ];
  return (
    <div className="">
      <Container className="subSectionWrapper ">
        <h2 className="text-center container-title mb-4">Benefits</h2>
        <Row>
          {benefits.map((e, i) => {
            return (
              <Col key={i} md={4} className="d-flex">
                <BenefitsCard
                  
                  src={e.img}
                  title={e.title}
                  bodycopy={e.bodycopy}
                />
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
}
